import React from 'react';

import type { ConsentReturn } from '@app/crud/customers/customer.type';

import { Icon } from '@app/components/Icon';

interface ConsentIconsProps {
    consents?: ConsentReturn[];
}

export const getConsentVariant = (value: boolean | null) => {
    if (value === null) return 'secondary';

    return value ? 'success' : 'danger';
};

const CONSENT_ICON_CLASSES = {
    success: 'kt-font-success',
    danger: 'kt-font-danger',
    secondary: 'text-muted',
};

export const getConsentIconClass = (value: boolean | null) => CONSENT_ICON_CLASSES[getConsentVariant(value)];

const ConsentIcons = ({ consents }: Readonly<ConsentIconsProps>) => {
    if (!consents) return null;

    const consent = consents[0];

    return (
        <div>
            <Icon icon="mobile" className={getConsentIconClass(consent?.gdprPhone)} />
            <Icon icon="comments" className={getConsentIconClass(consent?.gdprEmail)} />
            <br />
            <Icon icon="envelope" className={getConsentIconClass(consent?.gdprSms)} />
        </div>
    );
};

export default ConsentIcons;
